import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
import * as d3 from "d3";
import * as crossfilter from "crossfilter2/crossfilter";
import reductio from "reductio";

/* 
dc-chart object
*/

const weatherChartFunc = (divRef, ndx) => {

    // create a fake group to  remove the nulls 
    function remove_empty_bins(source_group) {
        return {
            all: function () {
                return source_group.all().filter(function (d) {
                    //return Math.abs(d.value) > 0.00001; // if using floating-point numbers
                    return d.value !== 0; // if integers only
                });
            },
        };
    }
  // dimension by Month
  var months = ndx.dimension((d) => {
    return d.month;
  });

  // get the monthly precipitation and tempreature for every county
  const temp = months.group().reduceSum((d) => d.monthly_Temperature);
  const rainfall = months.group().reduceSum((d) => d.monthly_Precipitation);

    // compute the total rainfall for the whole year by summing monthly precipitation
    // tempreature
    const all_precipitation = months.groupAll().reduceSum((d) => d.annual_Precipitation).value();
    const  total_anual_prep = all_precipitation
    // reduce to anuall tempreature and precipitation.
    const all_tempreature = months.groupAll().reduceSum((d) => d.monthly_Temperature).value();
    let total_temp = all_tempreature



  var compositeChartDate = dc.compositeChart(divRef); // dc composite chart instance

  var minDate = d3.timeDay.offset(new Date(2019, 1, 1), -45); // create offset to avoid clipping x-axis values
  var maxDate = d3.timeDay.offset(new Date(2019, 11, 31), 0); // date range 
  //  external functins
    compositeChartDate
        .width(400)
        .height(220)
        .transitionDuration(1500)
        .margins({ top: 45, right: 45, bottom: 25, left: 45 })
        .dimension(months)

        // .mouseZoomable(true)
        .shareTitle(false)
        // .x(d3.scaleTime().domain([new Date(2018, 12, 31), new Date(2019, 11, 31)]))
        .x(d3.scaleTime().domain([minDate, maxDate]))
        .round(d3.timeMonth.round)
        .xUnits(d3.timeMonths)
        .elasticY(true)
        .renderHorizontalGridLines(false)
        .legend(dc.legend().x(120).y(10).itemHeight(13).gap(5).horizontal(true))
        .brushOn(false)
        .on("filtered", function (chart, filter) { //check whether  the chart has some filters 
          var sel = chart.filterPrinter()(chart.filters());
          console.log("selected filters are:" + sel);
        })
        .ordering(false) // prevent default ordering and order by date e.g jan,feb,march e.t.c
        .xAxisPadding(20)
        // combine all the charts in one composite chart.
        .compose([
            dc
                .barChart(compositeChartDate)
                .group(remove_empty_bins(rainfall), "Rainfall(mm)")
                .gap(8)
                .valueAccessor((d) => {
                    
                    return d.value / 47; // by default return avg for the 12 months
                })

                .on("pretransition  ", function (chart) {
                    chart.valueAccessor((d) => {
                        
                        let a = d.value
                       
                        let b = total_anual_prep

                       
                        if (a < b) {
               
                            return a
                        } else {
                           return b/47
                           
                        }
                    });

                })
                .centerBar(true)
                .colors(["#7BA7CC"]),
            dc
                .lineChart(compositeChartDate)
                .group(remove_empty_bins(temp), "Temperature(°C)")
                .valueAccessor((d) => {
          
                    return d.value / 47;
                })
                
                .on("pretransition  ", function (chart) {
                    chart.valueAccessor((d) => {
                        //console.log("totals :" + total_anual_prep)
                        let a = d.value
                        //console.log("a " + a )
                        let b = total_temp

                        //console.log("b " + b)
                        if (a < b) {
                            //console.log("First if statement: " + a)
                            // on stransition return the value of the current key
                            return a
                        } else if (a !== b) {
                           /* console.log(a/b)*/
                            return a / 47
                            //console.log("second if statement: " + a)
                        }
                    });

                })
                .ordinalColors(["orange"])
                .useRightYAxis(true),
        ])
    compositeChartDate

        .xAxis()

        .ticks(d3.timeMonth, 1)

        .tickFormat(d3.timeFormat("%b"))

  // compositeChartDate
  //   .rightYAxis()
    // .tickValues([0, 5, 10, 15, 20, 25, 30, 35, 40]);
    return compositeChartDate;

};

export const WeatherChart = (props) => (
  <ChartTemplate
    chartFunction={weatherChartFunc}
    // title="Climate Conditions
  />
);
